export default "__VITE_ASSET__fd0e5740__"